<template>
  <section class="ctn">
    <heim-card>
      <header>
        <h1>{{ $t('Error404') }}</h1>
      </header>
        <section>
          <main>
            <div class="row">
              <div class="inputs">
                <p>{{ $t('pageError404') }}</p>
                <router-link to="/" exact>
                    {{ $t('GoToHomepage') }}
                </router-link>
              </div>
            </div>
          </main>
        </section>
    </heim-card>
  </section>
</template>

<script>
import HeimCard from "@/components/layout/card/heim-card.vue";

export default {
  name: "Error404",
  components: {
    HeimCard
  }
};
</script>
